import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOvereenkomst = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M20 28.02a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M31 33.52H12v-1h19z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m27.9 10.06 3.1 3.06-18.41 18.37L8 33l1.53-4.59zm6.12 0L31 7l-1.57 1.53 3.06 3.06z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.735 11.542a1.26 1.26 0 0 0-1.744.172l-.013.015-6.624 6.625-.707-.708 6.596-6.596a2.26 2.26 0 0 1 3.145-.266l.018.015 1.298 1.297-.707.708z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOvereenkomst);

export default ForwardRef;
